export default "__VITE_ASSET__ded74dc7__"